/* ============ AROMANTE ============ */
(function () {
  'use strict';

  /* ---- reveal on scroll ---- */
  var faders = document.querySelectorAll('.fade');
  if ('IntersectionObserver' in window && faders.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .06 });
    faders.forEach(function (el) { io.observe(el); });
  } else {
    faders.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- gallery ---- */
  var main = document.getElementById('galMain');
  if (main) {
    document.querySelectorAll('.gal-thumbs button').forEach(function (b) {
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        main.src = b.dataset.src;
        document.querySelectorAll('.gal-thumbs button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
      });
    });
  }

  /* ---- buy box ---- */
  var opts = document.getElementById('bundleOpts');
  if (!opts) return;

  var FRAGS = ['Sweet Orange', 'Lavender', 'Vanilla', 'White Blossom', 'Hotel Luxe'];
  var grid = document.getElementById('fgrid');
  var fsel = document.getElementById('fsel');
  var fcount = document.getElementById('fcount');
  var fnote = document.getElementById('fnote');
  var fhint = document.getElementById('fragHint');
  var prop = document.getElementById('fragProp');
  var vidInput = document.getElementById('variantId');
  var atc = document.getElementById('atcBtn');
  var pPrice = document.getElementById('pPrice'), pWas = document.getElementById('pWas'), pSave = document.getElementById('pSave');
  var sPrice = document.getElementById('sPrice'), sWas = document.getElementById('sWas');

  var qty = {};          // scent -> quantity
  var need = 3;          // bottles required by the selected bundle
  var current = 'trio';

  /* Shopify variants (when available) */
  var variants = [];
  try {
    var raw = document.getElementById('variant-data');
    variants = raw ? JSON.parse(raw.textContent) : [];
    if (!Array.isArray(variants)) variants = [];
  } catch (e) { variants = []; }

  function variantFor(key) {
    if (!variants.length) return null;
    var map = {
      essenziale: ['essential', '1 scent'],
      trio: ['trio', '3 scents'],
      collezione: ['collection', '5 scents', 'all scents']
    };
    var needles = map[key] || [];
    for (var i = 0; i < variants.length; i++) {
      var t = ((variants[i].title || '') + ' ' + (variants[i].option1 || '')).toLowerCase();
      for (var j = 0; j < needles.length; j++) if (t.indexOf(needles[j]) > -1) return variants[i];
    }
    var idx = { essenziale: 0, trio: 1, collezione: 2 }[key];
    return variants[idx] || variants[0];
  }

  function usd(n) {
    var v = Math.round(n * 100) / 100;
    return '$' + (v % 1 === 0 ? v.toString() : v.toFixed(2));
  }

  function total() {
    return FRAGS.reduce(function (s, f) { return s + (qty[f] || 0); }, 0);
  }

  function render() {
    var t = total();
    grid.querySelectorAll('.fitem').forEach(function (it) {
      var f = it.dataset.frag, q = qty[f] || 0;
      it.classList.toggle('sel', q > 0);
      it.querySelector('.fqty').textContent = q;
    });
    var ok = t === need;
    fcount.textContent = t + ' of ' + need + ' selected';
    fcount.classList.toggle('done', ok);
    if (atc) {
      atc.disabled = !ok;
      atc.textContent = ok ? 'Add to cart'
        : (t < need ? 'Choose ' + (need - t) + ' more ' + (need - t === 1 ? 'scent' : 'scents')
                    : 'Remove ' + (t - need));
    }
    if (prop) {
      prop.value = FRAGS.filter(function (f) { return qty[f]; })
        .map(function (f) { return qty[f] > 1 ? f + ' ×' + qty[f] : f; }).join(' · ');
    }
  }

  function setBundle(key) {
    current = key;
    var label = opts.querySelector('[data-bundle="' + key + '"]');
    if (!label) return;
    need = parseInt(label.dataset.need, 10);
    var price = parseFloat(label.dataset.price), was = parseFloat(label.dataset.was);

    var v = variantFor(key);
    if (v) {
      if (vidInput) vidInput.value = v.id;
      if (typeof v.price === 'number') price = v.price / 100;
      if (typeof v.compare_at_price === 'number' && v.compare_at_price > v.price) was = v.compare_at_price / 100;
    }

    if (pPrice) pPrice.textContent = usd(price);
    if (pWas) pWas.textContent = usd(was);
    if (pSave) pSave.textContent = 'You save ' + usd(was - price);
    if (sPrice) sPrice.textContent = usd(price);
    if (sWas) sWas.textContent = usd(was);

    /* reset scent selection */
    qty = {};
    if (need === 5) {
      FRAGS.forEach(function (f) { qty[f] = 1; });
      fsel.classList.add('locked');
      fnote.textContent = 'The Collection includes all five essences — nothing to choose.';
      if (fhint) fhint.textContent = 'All included';
    } else {
      fsel.classList.remove('locked');
      fnote.textContent = need === 1
        ? 'Tap the scent you want shipped with your diffuser.'
        : 'You can also take two bottles of the same essence — use + and −.';
      if (fhint) fhint.textContent = need === 1 ? 'Choose 1' : 'Choose ' + need;
    }
    render();
  }

  function bump(f, d) {
    if (need === 5) return;
    var q = qty[f] || 0;
    if (need === 1) {                       // single choice
      qty = {};
      if (d > 0 || q === 0) qty[f] = 1;
      render();
      return;
    }
    var t = total();
    if (d > 0 && t >= need) {               // already full
      render();
      return;
    }
    q += d;
    if (q <= 0) delete qty[f]; else qty[f] = q;
    render();
  }

  grid.addEventListener('click', function (ev) {
    var step = ev.target.closest('[data-step]');
    var item = ev.target.closest('.fitem');
    if (!item) return;
    ev.preventDefault();
    if (step) { bump(item.dataset.frag, parseInt(step.dataset.step, 10)); return; }
    if (need === 1) { bump(item.dataset.frag, 1); return; }
    var q = qty[item.dataset.frag] || 0;
    if (q > 0 && total() >= need) bump(item.dataset.frag, -1);
    else bump(item.dataset.frag, 1);
  });

  opts.addEventListener('change', function (ev) {
    if (ev.target.name === 'bundle') setBundle(ev.target.value);
  });

  /* preselect from URL (?bundle=trio) */
  var q = new URLSearchParams(location.search).get('bundle');
  var start = ['essenziale', 'trio', 'collezione'].indexOf(q) > -1 ? q : 'trio';
  var input = opts.querySelector('input[value="' + start + '"]');
  if (input) input.checked = true;
  setBundle(start);
})();
